import React, { Component } from 'react';
import { Field, ErrorMessage } from 'formik';
import { iconForField } from '../../common/custom/icon-library';
import FormFieldWithLabel from '../common/FormFieldWithLabel';
import TooltipInfo from '../../common/docs/TooltipInfo';

class ConsoleLogOptions extends Component {
  render() {
    const { values } = this.props;

    return (
      <div style={{ marginLeft: '30px' }}>
        <div className="form-group">
          <div className="input-group">
            <div className="input-group-prepend" title="Enable Console Logs">
              <span className="input-group-text">
                <i className={`wb ${iconForField('boolean-toggle')}`}></i>
              </span>
            </div>
            <div className="form-check">
              <label className="form-check-label">
                <Field
                  type="checkbox"
                  name="enableConsoleLog"
                  className="form-check-input"
                  title="Enable Console Logs"
                />
                Enable Console Logs
                <span className="form-check-sign">
                  <span className="check"></span>
                </span>
              </label>
            </div>
            <TooltipInfo
              title={`Enable it to console log in your web browser.`}
              headerText={`What's this ?`}
              showHeader={true}
              showArrow={true}
              append={true}
            />
          </div>
          <ErrorMessage name="enableConsoleLog" component="p" className="text-error ml-5" />
        </div>
        {values['enableConsoleLog'] && (
          <div style={{ marginLeft: '30px' }}>
            <div className="form-group">
              <FormFieldWithLabel
                cta={false}
                label="Entry Log Message"
                icon="text"
                infoIcon={true}
                infoDescription={`Enter the log message which you want to display as soon as action is triggered in your web browser.`}
              >
                <Field
                  type="text"
                  name="startConsoleLog"
                  className="form-control form-control-sm"
                  autoComplete="off"
                  placeholder="Log message on entry"
                />
              </FormFieldWithLabel>
              <ErrorMessage name="startConsoleLog" component="p" className="text-error ml-5" />
            </div>
            <div className="form-group">
              <FormFieldWithLabel
                cta={false}
                label="Exit Log Message"
                icon="text"
                infoIcon={true}
                infoDescription={`Enter the log message which you want to display just before action leaves in your web browser.`}
              >
                <Field
                  type="text"
                  name="endConsoleLog"
                  className="form-control form-control-sm"
                  autoComplete="off"
                  placeholder="Log message on exit"
                />
              </FormFieldWithLabel>
              <ErrorMessage name="endConsoleLog" component="p" className="text-error ml-5" />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default ConsoleLogOptions;
